export function getWindowHeight() {
	return ( window.innerHeight || document.documentElement.clientHeight );
}

export function getWindowWidth() {
	return ( window.innerWidth || document.documentElement.clientWidth );
}

export function getQueryString( query_object ) {
	const query_pieces = [];
	for ( const key in query_object ) {
		if ( !query_object.hasOwnProperty( key ) ) {
			continue;
		}
		if ( query_object[key] instanceof Array ) {
			query_pieces.push( '&' + key.replace( '[]', '' ) + '='  );
			query_pieces.push( ( query_object[key][0] ? query_object[key][0] : '' ) );
			for ( let i = 1; i < query_object[key].length; i++ ) {
				query_pieces.push( ( query_object[key][i] ? '+' + query_object[key][i] : '' ) );
			}
			continue;
		}
	}

	if ( query_pieces.length === 0 ) {
		return '';
	}

	return '?' + query_pieces.join( '' );
}

export function getQueryObject( query_string ) {
	const query_object = {};
	const pairs = ( query_string[0] === '?' ? query_string.substr( 1 ) : query_string ).split( '&' );
	for ( let i = 0; i < pairs.length; i++ ) {
		const pair = pairs[i].split( '=' );
		if ( pair !== '' ) {
			let key = decodeURIComponent( pair[0] );
			const value = decodeURIComponent( pair[1] || '' );
			if ( !( query_object[key] instanceof Array ) ) {
				query_object[key] = [];
			}
			query_object[key].push( value );
			continue;
		}
	}
	return query_object;
}

export const buildLividPlayers = ( videos ) => {
	videos.forEach( video => {
		const player_container = video.querySelector( '.video__player' );
		if ( !player_container ) {
			return;
		}

		function insertIframe( autoplay ) {
			if ( player_container.querySelector( 'iframe' ) ) {
				return;
			}

			const url = new URL( player_container.dataset.embedSrc );
			if ( autoplay ) {
				url.searchParams.set( 'autoplay', '1' );
			}
			const src = url.toString();

			const iframe = document.createElement( 'iframe' );
			iframe.style.position = 'absolute';
			iframe.style.top = '0';
			iframe.style.left = '0';
			iframe.style.width = '100%';
			iframe.style.height = '100%';
			iframe.setAttribute( 'allow', 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share' );
			iframe.setAttribute( 'allowfullscreen', '' );
			iframe.setAttribute( 'frameborder', '0' );
			iframe.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
			iframe.src = src;

			player_container.appendChild( iframe );
		}

		if ( !video.querySelector( '.video__placeholder' ) && !video.querySelector( '.video__play-button' ) ) {
			insertIframe( false );
			return;
		}

		video.onclick = () => {
			insertIframe( true );
			video.classList.add( 'video--started' );
		};
	} );
};

export const buildYoutubePlayers = ( videos ) => {
	function createPlayers() {
		videos.forEach( video => {
			const player_container = video.querySelector( '.video__player' );
			if ( !player_container || player_container.dataset.youtubePlayerInitialized ) {
				return;
			}
			player_container.dataset.youtubePlayerInitialized = 'true';
			const video_id = player_container.dataset.videoId;

			const player = new YT.Player( player_container, {
				width: '1920',
				height: '1080',
				videoId: video_id,
				playerVars: {
					'playsinline': 1
				}
			} );

			video.onclick = ( e ) => {
				if ( e.target.classList.contains( 'video__placeholder' ) ||  e.target.classList.contains( 'video__play-button' ) ) {
					player.playVideo();
					video.classList.add( 'video--started' );
				}
			};
		} );
	}

	// If the API is already loaded (e.g. this is a re-run after cookie consent), create players immediately.
	if ( window.YT && window.YT.Player ) {
		createPlayers();
		return;
	}

	// Load API script
	const api_script = document.querySelector( '#youtube-script' );
	if ( !api_script ) {
		const script = document.createElement( 'script' );
		script.src = 'https://www.youtube.com/iframe_api';
		script.id = 'youtube-script';

		const first_script_tag = document.getElementsByTagName( 'script' )[0];
		first_script_tag.parentNode.insertBefore( script, first_script_tag );
	}

	const previous_ready_callback = window.onYouTubeIframeAPIReady;
	window.onYouTubeIframeAPIReady = () => {
		if ( typeof previous_ready_callback === 'function' ) {
			previous_ready_callback();
		}
		createPlayers();
	};
};